<ion-icon name="add" (click)="addToPlaylist(album._id, trackId)"></ion-icon>